module.exports = __webpack_public_path__ + "media/images/service/patent_bg-bf43690099e6bf58cfa1b085a326412e.jpg";